import styled, { css } from "styled-components";

export const InlineLinkMixing = css`
    color: ${({ theme }) => theme.colors.dodgerBlue};
    text-decoration: none;
    -webkit-font-smoothing: antialiased;

    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const InlineLink = styled.a`
    ${InlineLinkMixing}
`;
